import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import ActionViewPopUp from "../ActionViewPopUp";

const AllTasks = () => {
  const dispatch = useDispatch();
  const [flowGuid,setFlowGuid]=useState(null)
  const [taskId,setTaskId]=useState(null)
  const { applicationGuid } = useParams();
  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);

  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "fieldName",
        keyValueName: "fieldNameId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "researchProjectTitleInArabic",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "flowName",
      ShowStatus: true,
      NmaeColumn: "اسم المرحلة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "flowName",
        keyValueName: "flowName",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "taskType",
      ShowStatus: true,
      NmaeColumn: "نوع المهمة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "taskType",
        keyValueName: "taskType",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "taskStatusName",
      ShowStatus: true,
      NmaeColumn: "حالة المهمة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "taskStatusName",
        keyValueName: "taskStatusName",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "userName",
      ShowStatus: true,
      NmaeColumn: "المستخدم المُعيِّن",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "userName",
        keyValueName: "userName",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    // {
    //   KeyName: "ratingRate",
    //   ShowStatus: true,
    //   NmaeColumn: "معدل التقييم",
    //   TotalNumber: true,
    //   DropdownFiltration: {
    //     keyTextName: "applicantTypeAr",
    //     keyValueName: "applicantTypeAr",
    //   },
    //   DropdownFiltrationStatus: false,
    //   GroupOfColumns: false,
    // },
    // {
    //   KeyName: "evaluationStatus",
    //   ShowStatus: true,
    //   NmaeColumn: "حالة التقييم",
    //   TotalNumber: true,
    //   DropdownFiltration: {
    //     keyTextName: "statusNameAr",
    //     keyValueName: "appStatusId",
    //   },
    //   DropdownFiltrationStatus: false,
    //   GroupOfColumns: false,
    // },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        
        const obj = JSON.parse(e.target.value);
        closePopupEditComponent()
        setFlowGuid(obj.flowId)
        setTaskId(obj.taskId)
        // navigate("/SRFund/manager/EvaluationInformation/" + e.target.value);
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
      ShowActionTask:true
    },{
      // marks
      Click: async (e) => {

        const obj = JSON.parse(e.target.value);
        // closePopupEditComponent()
        setFlowGuid(obj.flowId)
        setTaskId(obj.taskId)
        navigate("/SRFund/manager/EvaluationInformation/" + obj.taskId);
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
      showMarksForViewAllTask:true
    },{
      //yesno
      Click: async (e) => {
       
        const obj = JSON.parse(e.target.value);
        console.log(obj,"sssssssdwdwdwd");
        
        // closePopupEditComponent()
        setFlowGuid(obj.flowId)
        setTaskId(obj.taskId)
        navigate("/SRFund/manager/InitialScreeningEvaluation/" +obj.taskId);
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
      ShowYesNoForAllTask:true
    },
  ];

  const RequestsManagerColumns = [];
  const FlowTrackingAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "empolyeeName",
      ShowStatus: true,
      NmaeColumn: "الموظف",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "actionName",
      ShowStatus: true,
      NmaeColumn: "الإجراء",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "flowName",
      ShowStatus: true,
      NmaeColumn: "المرحلة",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "craeteDate",
      ShowStatus: true,
      NmaeColumn: "تاريخ الإجراء",
      TotalNumber: false,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"aI_ApplicationInformationId"}
        valueButtonAction={"aI_ApplicationInformationId"}
        URL={`api/Tasks/GetAllTasksApplicationByGuid`}
        UrlBody={{
          applicationInformationId: applicationGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        RequestsManagerValue={true}
        accessor={RequestAccessor}
        titelTable={"المهام"}
        selectRowNumber={false}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        setEndPagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={PopupComponentEditStatus}
            isPopupOpenFunction={closePopupEditComponent} 
            title={"الإجراءات التي تمت على الطلب"}
            componentBody={
              <ActionViewPopUp
                taskId={taskId}
                flowGuid={flowGuid}
              />
            }
            maxWidth="700px"
            maxHeight="500px"
          />
        }
      />
      <TableAHSF
        culomEdite={[]}
        uniqueValue={"craeteDate"}
        valueButtonAction={"applicationNumber"}
        URL={`api/FlowTracking/GetFlowTrackingByApplicationId`}
        UrlBody={{
          applicationInformationId: applicationGuid,
        }}
        staticKeyEdite={[]}
        accessor={FlowTrackingAccessor}
        titelTable={"الإجراءات على الطلبات"}
        selectRowNumber={false}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={false}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"craeteDate"}
        dateKey="craeteDate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={[]}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: "رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
      />
      
    </>
  );
};

export default AllTasks;
